import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Home, ArrowLeft } from 'lucide-react'
import SEO from '../components/SEO'

export default function NotFoundPage() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you are looking for does not exist." />
      <section className="min-h-screen flex items-center justify-center bg-earth-50 pt-20">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center px-4">
          <div className="text-9xl font-black gradient-text mb-4">404</div>
          <h1 className="text-3xl font-bold text-earth-900 mb-4">Page Not Found</h1>
          <p className="text-earth-500 mb-8 max-w-md mx-auto">The page you're looking for doesn't exist or has been moved.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="btn-primary"><Home className="w-5 h-5" />Back to Home</Link>
            <button onClick={() => window.history.back()} className="btn-secondary"><ArrowLeft className="w-5 h-5" />Go Back</button>
          </div>
        </motion.div>
      </section>
    </>
  )
}
